import React from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import pushToAnalytics from "../../../../utils/analytics";
import Image from "../../Image";
import Markdown from "../../Markdown";
import Button from "../../NewForms/Button";
import HeadlineItem from "../ContentElement/HeadlineItem";
import { SideNavContainer } from "../SideNavContainer";
import useSideNavStore from "../SideNavContainer/store";

const Text = styled(Markdown)`
    font-size: 1em;
    ${({ theme }) => css`
        color: ${theme.colors.blue.toString()};
    `};
`;

const Container = styled.div``;

const ContentContainer = styled.div`
    ${({ theme }) => css`
        ${theme.paddings.containerOuter.right}
        ${theme.paddings.containerOuter.left}
    `}
`;

const Headline = styled(HeadlineItem)`
    hyphens: auto;
    word-break: break-word;
    overflow-wrap: break-word;
    order: 1;
    ${({ theme }) =>
        theme.breakpoints.from.medium.css`
            grid-column: 1 / span 2;
            order: 1;
      `}
`;

const Grid = styled.div`
    display: grid;
    ${(p) =>
        p.gridStyle === "1"
            ? p.theme.breakpoints.from.medium.css`
            grid-template-columns: 1fr 1fr;`
            : p.gridStyle === "2"
            ? p.theme.breakpoints.from.medium.css`
            grid-template-columns: 1fr 2fr;`
            : p.theme.breakpoints.from.medium.css`
            grid-template-columns: 2fr 1fr;`}

    gap: 20px;
`;

const TextContainer = styled.div`
    order: 2;
    display: flex;
    gap: 20px;
    flex-direction: column;

    strong {
        color: ${({ theme }) => theme.colors.blue.toString()};
    }
    ${(p) =>
        p.side === "right"
            ? p.theme.breakpoints.from.medium.css`
             order: 3;`
            : p.theme.breakpoints.from.medium.css`
             order: 2;`}
`;

const ImageContainer = styled.div`
    order: 3;
    ${(p) =>
        p.side === "right"
            ? p.theme.breakpoints.from.medium.css`
             order: 2;`
            : p.theme.breakpoints.from.medium.css`
             order: 3;`}
`;

const CustomButton = styled(Button)`
    width: 100%;
    display: block;
    ${({ theme }) =>
        theme.breakpoints.from.medium.css`
            display: unset;
            width: fit-content;
      `}
`;

const TextImgGrid = ({
    name,
    text,
    side,
    linkOptional,
    gridStyle = "1",
    image,
    eventTracking,
}) => {
    const theme = useTheme();
    const [paddingLeft] = useSideNavStore((state) => [state.paddingLeft]);
    return (
        <Container>
            <ContentContainer>
                <SideNavContainer paddingLeft={paddingLeft}>
                    <Grid gridStyle={gridStyle}>
                        {name && (
                            <Headline
                                headline={3}
                                color={theme.colors.red.toString()}
                            >
                                {name}
                            </Headline>
                        )}
                        {text && (
                            <TextContainer side={side}>
                                <Text>{text}</Text>
                                {linkOptional &&
                                    linkOptional.text &&
                                    linkOptional.href && (
                                        <CustomButton
                                            to={linkOptional.href}
                                            onClick={() =>
                                                eventTracking &&
                                                pushToAnalytics(eventTracking, {
                                                    clicked: "Anfrage starten",
                                                })
                                            }
                                        >
                                            {linkOptional.text}
                                        </CustomButton>
                                    )}
                            </TextContainer>
                        )}
                        {image?.src && (
                            <ImageContainer side={side}>
                                <Image {...image} />
                            </ImageContainer>
                        )}
                    </Grid>
                </SideNavContainer>
            </ContentContainer>
        </Container>
    );
};

export default TextImgGrid;
